/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Pause Fill',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M0 12C0 5.38308 5.38335 0 12 0C18.6172 0 24 5.38308 24 12C24 18.6169 18.6169 24 12 24C5.38308 24 0 18.6169 0 12Z"
            fill="currentColor"
          />{' '}
          <path
            d="M14.9974 5C14.0108 5 13.2004 5.81176 13.2004 6.79834V17.5973C13.2004 18.5837 14.0108 19.3944 14.9974 19.3944H16.1971C17.1836 19.3944 18 18.5837 18 17.5973V6.79834C18 5.81176 17.1835 5 16.1971 5H14.9974Z"
            fill="white"
          />{' '}
          <path
            d="M7.80179 5C6.81532 5 6 5.81176 6 6.79834V17.5973C6 18.5837 6.81534 19.3944 7.80179 19.3944H9.00256C9.98914 19.3944 10.7997 18.5837 10.7997 17.5973V6.79834C10.7997 5.81176 9.98914 5 9.00256 5H7.80179Z"
            fill="white"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
